import { getStore } from '@ingka/singleton-store';
const ICON_STORE_ID = 'skapa-icon-store';
// The store will be initialized with a generic Map inside the getStore on first request.
const iconStore = getStore(ICON_STORE_ID);
export function registerIcon(name_or_description, paths) {
    let _name;
    let _paths;
    if (typeof name_or_description === 'object') {
        // It's an icon description
        _name = name_or_description.iconName;
        _paths = name_or_description.paths;
    }
    else if (Array.isArray(paths)) {
        // It's a name and paths combo
        _name = name_or_description;
        _paths = paths;
    }
    else {
        throw new Error(`Invalid use of registerIcon:\nArg[0]: ${name}\nArg[1]: ${paths} `);
    }
    if (!iconStore.has(_name))
        iconStore.set(_name, _paths);
}
export const getPaths = (name) => {
    if (!name)
        return;
    const result = iconStore.get(name);
    if (!result)
        console.error(`The icon: '${name}' has not been loaded yet!\nDid you forget to import '@ingka/icon-store/${name}'?`);
    return result;
};
